/*
We're constantly improving the code you see. 
Please share your feedback here: https://form.asana.com/?k=uvp-HPgd3_hyoXRBw1IcNg&d=1152665201300829
*/

import React from "react";

export const VuesaxBoldUser = ({ className }) => {
  return (
    <svg
      className={`vuesax-bold-user ${className}`}
      fill="none"
      height="24"
      viewBox="0 0 24 24"
      width="24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        className="path"
        d="M12 12C14.3012 12 16.1667 10.1345 16.1667 7.83333C16.1667 5.53214 14.3012 3.66666 12 3.66666C9.69882 3.66666 7.83334 5.53214 7.83334 7.83333C7.83334 10.1345 9.69882 12 12 12Z"
        fill="white"
      />
      <path
        className="path"
        d="M12 14.0833C7.82499 14.0833 4.42499 16.8833 4.42499 20.3333C4.42499 20.5667 4.60832 20.75 4.84165 20.75H19.1583C19.3917 20.75 19.575 20.5667 19.575 20.3333C19.575 16.8833 16.175 14.0833 12 14.0833Z"
        fill="white"
      />
    </svg>
  );
};
